import { queryOptions } from '@tanstack/react-query';
import { atFaultDriverQueryFunction } from './atFaultDriverQueryFunction';

export const atFaultDriverQueryOptions = () => {
  return queryOptions({
    queryKey: ['atFaultIdentifier'],
    queryFn: () => atFaultDriverQueryFunction(),
    select: (data) => {
      return data?.map((item) => ({
        label: item.fa_const,
        value: item.const,
      }));
    },
  });
};
